import { ReducerAction } from 'store/modules/types';

import { TokenRequest, Types } from './types';

export function registraTokenRequest(data: TokenRequest): ReducerAction {
	return {
		type: Types.TOKEN_REQUEST,
		payload: data,
	};
}

export function registraTokenSuccess(data: string): ReducerAction {
	return {
		type: Types.TOKEN_SUCCESS,
		payload: data,
	};
}

export function registraTokenClear(): ReducerAction {
	return {
		type: Types.TOKEN_CLEAR,
		payload: null,
	};
}
